import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationActionTypes } from '../../models/actions.enum';

@Pipe({
    name: 'appActionButtonStyle',
    standalone: false
})
export class AppActionButtonStylePipe implements PipeTransform {
    transform(applicationAction: ApplicationActionTypes): string | undefined {
        const launchStyle = 'primary-alt';
        const comingSoonStyle = 'secondary';
        const learnMoreStyle = 'dark-blue';

        const matcher: { [key in ApplicationActionTypes]: string } = {
            [ApplicationActionTypes.Launch]: launchStyle,
            [ApplicationActionTypes.ComingSoon]: comingSoonStyle,
            [ApplicationActionTypes.LearnMore]: learnMoreStyle
        };
        return matcher[applicationAction];
    }
}
